import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { OFFER_ANCHOR } from '../data/content';
type CtaButtonProps = {
  price?: string;
  href?: string;
  fullWidth?: boolean;
  size?: 'md' | 'lg';
  className?: string;
  label?: string;
};
export function CtaButton({
  price,
  label = 'Quiero capacitarme',
  href = OFFER_ANCHOR,
  fullWidth = false,
  size = 'md',
  className = ''
}: CtaButtonProps) {
  return <a href={href} className={`btn-gold group relative inline-flex items-center justify-center gap-3 overflow-hidden rounded-2xl px-6 font-display text-ink transition-[transform,filter] duration-150 ease-out hover:brightness-105 active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 sm:px-8 ${size === 'lg' ? 'py-5' : 'py-4'} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-26" data-mp="qjikrtxvt433">
      <span className="flex flex-col items-center leading-tight sm:flex-row sm:gap-1.5" data-id="element-27" data-mp="19buvp52lpdou">
        <span className={`text-balance text-center font-extrabold uppercase tracking-wide ${size === 'lg' ? 'text-[15px] sm:text-lg' : 'text-sm sm:text-base'}`} style={{
        fontSize: "18px",
        fontWeight: "900"
      }} data-id="element-28" data-mp="15ahp2srop6gv">
          <span aria-hidden="true" data-id="element-29" data-mp="39zj01wmxabw3">⚡ </span>{label}
        </span>
        {price}
      </span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-30" data-mp="3ewswhw8qbntf" />
    </a>;
}